import "./Row.css";

function Row(props) {
  return <div className="Row">{props.children}</div>;
}
export default Row;
